import { loadConfig } from '../../../configs/config'

loadConfig().then(() => import('./bootstrap'))
